import { ReactElement, useState } from "react";
import SidePanelSection from "../SidePanelSection/SidePanelSection";
import "./CollapsablePannelSection.css";

interface CollapsablePanelSectionProps {
  sectionTitle: string;
  location: Location;
  tagName: (props: { [key: string]: any }) => ReactElement;
  list?: any[];
  refresh?: () => void;
}

export function CollapsablePanelSection({
  sectionTitle,
  list,
  tagName,
  location,
  refresh,
}: CollapsablePanelSectionProps) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  if (list?.length === 0) {
    return null;
  }
  return isCollapsed ? (
    <div className="side-panel-section-collapsed" onClick={() => setIsCollapsed(false)}>
      {sectionTitle}
    </div>
  ) : (
    <SidePanelSection
      sectionTitle={sectionTitle}
      list={list}
      location={location}
      tagName={tagName}
      refresh={refresh}
      collapse={() => setIsCollapsed(true)}
    />
  );
}
